
import { Component, Prop, Vue } from "vue-property-decorator";
import NodeType from "../../types/NodeType";

@Component({
  components: {},
})
export default class NodeName extends Vue {
  // exclamation means that it is required, which means it does not need to be
  // initialized with a constructor
  @Prop({ required: true }) node!: NodeType;

  // left click event handler (attached to each node)
  @Prop({ required: true }) handleNodeLeftClick!: (
    event: any,
    node: NodeType
  ) => any;

  // right click event handler (attached to each node)
  @Prop({ required: true }) handleNodeRightClick!: (
    event: any,
    node: NodeType
  ) => any;

  get someChildrenVisible(): boolean {
    return this.node.children.some((child) => child.show);
  }

  get haveLeftPadding(): boolean {
    if (this.node.children && !this.node.children.length) {
      return true;
    }
    if (!this.someChildrenVisible) {
      return true;
    }
    return false;
  }
}
